import { signal } from "@angular/core";

import {
  CalculatedBalanceCollection,
  CalculatedBalanceParams,
} from "@bitwarden/web-vault/app/services/store/calculated-balance.collection.abstraction";

export class BalanceCurrentCalculatedCollection extends CalculatedBalanceCollection {
  protected readonly type = "BalanceCurrent";
  protected calculations: number;

  protected _balances = signal<number>(null);
  readonly balances = this._balances.asReadonly();

  /**
   * Uses the filteredTransactions stored on the calculation store to update
   * the calculations for balance by account
   */
  async updateCalculations(parameters: CalculatedBalanceParams): Promise<void> {
    const isStale = this.staleCheck();
    const filteredDate = parameters?.period?.endDate ? parameters.period.endDate : new Date();
    const balance: number = await this.getCurrentBalance(
      parameters.webWorkerQueue,
      parameters.calculatedTransactions,
      filteredDate,
    );

    if (isStale()) {
      return;
    }
    this.setBalances(balance);
  }

  getCalculations(): number {
    return this.calculations;
  }

  protected clearCalculations(): void {
    this.calculations = null;
    this._balances.set(null);
  }

  triggerChanges(): void {}

  private setBalances(balance: number): void {
    this.calculations = balance;
    this._balances.set(this.calculations);
  }
}
